import React from 'react';
import LectureQAManagementComponent from '../../../components/admin/community/LectureQAManagementComponent';

const LectureQAManagement: React.FC = () => {
  return <LectureQAManagementComponent />;
};

export default LectureQAManagement;
